const weight = { KG: 'KG' };
const volume = { CFT: 'CFT' };
const dimensionUnit = {
  MM: 'MM',
  CM: 'CM',
  IN: 'IN',
  FT: 'FT',
  YD: 'YD',
  M: 'M',
};

const packageType = {
  BINS: 'BINS',
  TROLLEYS: 'TROLLEYS',
  CORRUGATED_BOX: 'CORRUGATED_BOX',
  PALLETS: 'PALLETS',
};

const packageLoadType = {
  QUANTITY: 1,
  WEIGHT: 2,
  FITMENT: 3,
};

const packageStatus = {
  ACTIVE: 1,
  INACTIVE: 0,
};

const packages = {
  headerMapping: {
    'Package id': 'package_id',
    Description: 'description',
    'Max stack': 'max_stack',
    Weight: 'weight',
    Volume: 'volume',
    Length: 'length',
    breadth: 'breadth',
    Height: 'height',
    'Weight capacity': 'weight_capacity',
    'Volume capacity': 'volume_capacity',
    Type: 'type',
    'Load type': 'load_type',
    'Max sku': 'max_no_sku',
    'Max in truck': 'max_in_truck',
    'Max weight': 'max_weight',
    'Can load on top': 'can_load_on_top',
  },
};

module.exports = {
  packageWeightUnit: weight,
  packageVolumeUnit: volume,
  packageDimensionUnit: dimensionUnit,
  packageType,
  packageStatus,
  packages,
  packageLoadType,
};
